import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import HouseholdSectionMemberContainer from './HouseholdSectionMember/HouseholdSectionMemberContainer';
import HouseholdSectionMemberLegacy from './HouseholdSectionMemberLegacy/HouseholdSectionMemberLegacy';


const HouseholdSectionMemberPicker = ({ resource }) => {
  const {
    householdResource,
    household,
    updateHousehold,
  } = useSimpleHousehold();

  return pick(resource, {
    [fr.relationships.householdSectionMember.name]: (
      <HouseholdSectionMemberContainer
        relationshipLink={resource?.relationship(fr.relationships.householdSectionMember.name)?.link('related')}
      />
    ),
  }, (
    <HouseholdSectionMemberLegacy
      householdResource={householdResource}
      household={household}
      updateHousehold={updateHousehold}
    />
  ));
};

HouseholdSectionMemberPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
HouseholdSectionMemberPicker.defaultProps = {};

export default HouseholdSectionMemberPicker;
